import httpClient from 'api/httpClient';
import { DealRoom } from 'models/DealRoom';
import { EnterpriseMember } from 'models/Enterprises';
import {
  EnterpriseAnalyticsDealRoomsByIndustry,
  EnterpriseAnalyticsDealRoomsByStatus,
  EnterpriseAnalyticsSummary,
  LeadsActivityAggregationResponse,
} from 'models/EnterprisesAnalytics';
import { PaginatedData } from 'models/PaginatedData';
import { Params } from 'react-router-dom';
import { DataRoom } from 'router/subrouters/DataRoom/models/DataRoom';

function getSummary(enterpriseId: string, params?: Params) {
  return httpClient.get<EnterpriseAnalyticsSummary>(
    `enterprise-analytics/enterprises/${enterpriseId}/summary`,
    {
      params,
    },
  );
}

function getDealsByStatus(enterpriseId: string, params?: Params) {
  return httpClient.get<Array<EnterpriseAnalyticsDealRoomsByStatus>>(
    `enterprise-analytics/enterprises/${enterpriseId}/by-status`,
    {
      params,
    },
  );
}

function getDealsByIndustry(enterpriseId: string, params?: Params) {
  return httpClient.get<Array<EnterpriseAnalyticsDealRoomsByIndustry>>(
    `enterprise-analytics/enterprises/${enterpriseId}/by-industry`,
    {
      params,
    },
  );
}

function getTopPerformingBrokers(enterpriseId: string, params?: Params) {
  return httpClient.get<PaginatedData<EnterpriseMember>>(
    `enterprise-analytics/enterprises/${enterpriseId}/top-brokers`,
    {
      params,
    },
  );
}

function getAllDeals(enterpriseId: string, params?: any) {
  return httpClient.get<PaginatedData<DealRoom>>(
    `enterprise-analytics/enterprises/${enterpriseId}/deals`,
    {
      params,
    },
  );
}

function getAllDataRooms(enterpriseId: string, params?: Params) {
  return httpClient.get<PaginatedData<DataRoom>>(
    `data-rooms/enterprises/${enterpriseId}`,
    {
      params,
    },
  );
}

function getLeadActivity(enterpriseId: string, dealRoomId: string) {
  return httpClient.get<LeadsActivityAggregationResponse>(
    `enterprise-analytics/enterprises/${enterpriseId}/by-leads-activity`,
    { params: { dealRoomId } },
  );
}

export default {
  getSummary,
  getDealsByStatus,
  getDealsByIndustry,
  getTopPerformingBrokers,
  getAllDeals,
  getAllDataRooms,
  getLeadActivity,
};
